import { render, staticRenderFns } from "./synapb.vue?vue&type=template&id=5e17a96e&scoped=true"
import script from "./synapb.vue?vue&type=script&lang=js"
export * from "./synapb.vue?vue&type=script&lang=js"
import style0 from "./synapb.vue?vue&type=style&index=0&id=5e17a96e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e17a96e",
  null
  
)

export default component.exports